import styled, { css } from 'styled-components';
import is, { isNot } from 'styled-is';

import { Flexer } from '@ontruck/orc';

const weightProps = ({ fontWeight = '500' }) => css`
  font-weight: ${fontWeight};
`;

const CellsWrapper = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'center',
}))`
  ${weightProps}

  ${isNot('transparent')`
    background: white;
  `}

  ${is('wrapperHeight')`
    height: ${(props) => `${props.wrapperHeight}px`};
  `}

  ${is('wrapperColumn')`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export default CellsWrapper;
